import styled, { css } from 'styled-components';

const baseStyles = css`
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
`;

export const Button = styled.button.attrs({ type: 'button' })`
    /* Reset default browser styles */
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: normal;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    -webkit-appearance: none;
    &::-moz-focus-inner {
        border: 0;
        padding: 0;
    }
    :focus {
        outline-style: none;
        box-shadow: none;
        border: none;
    }
    /* end of reset */

    ${baseStyles}

    :disabled {
        cursor: default;
    }
`;

export const Link = styled.a.attrs({ rel: 'noopener noreferrer' })`
    /* Reset default browser styles */
    text-decoration: none;
    color: inherit;
    /* end of reset */

    ${baseStyles}
`;
